import React from "react";
import { useStateValue } from "../../StateProvider";
import CheckoutProduct from "./CheckoutProduct";

function ReviewCart() {
  const [{ cart }] = useStateValue();
  return (
    <div className="checkout__items">
      {cart.map((item) => (
        <CheckoutProduct
          key={item.id}
          product_id={item.id}
          productImage={item.image}
          productName={item.title}
          price={item.price}
        />
      ))}
    </div>
  );
}

export default ReviewCart;
